import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Table, Spinner } from "reactstrap";
import * as url from "../../helpers/url_helper";
import { API_URL } from "../../helpers/api_helper";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import headers from "../Utility/headers";
import { Card, CardBody } from "reactstrap";
import DateHelper from "../../helpers/date_helper";

class ClientReviewList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notHaveAutoBCL: [],
            notHaveCouponScanner: [],
            loading: false,
        };
    }


    notify = (type, message) => {
        switch (type) {
            case 'info':
                toast.info(message);
                break;
            case 'error':
                toast.error(message);
                break;
            case 'success':
                toast.success(message);
                break;
            default:
                break;
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        const [key, id] = name.split('_');
        if (key === 'site') {
            this.setState(prevState => ({
                siteUrl: {
                    ...prevState.siteUrl,
                    [name]: value
                }
            }));
        } else if (key === 'website') {
            this.setState(prevState => ({
                websiteUrls: {
                    ...prevState.websiteUrls,
                    [name]: value // Update specific website URL
                }
            }));
        } else if (key === 'coupons') {
            this.setState(prevState => ({
                couponsData: {
                    ...prevState.couponsData,
                    [name]: value // Update specific coupon
                }
            }));
        }
    };


    getDomainName = (domain) => {
        if (!domain) return '';
        const parts = domain.split('.');
        if (parts.length < 2) return '';
        if (parts.length === 3) {
            if (parts[0] === 'www') {
                return parts[1];
            }
            return parts[0];
        }
        return parts[parts.length - 2];
    }

    async componentDidMount() {
        this.setState({ loading: true });
        try {
            const response = await fetch(`${API_URL}${url.GET_CLIENT_REVIEW_LIST}`, { method: 'get', headers: headers() });
            const responseData = await response.json();
            if (responseData.status) {
                const { notHaveAutoBCL, notHaveCouponScanner } = responseData.data;
                this.setState({
                    notHaveAutoBCL,
                    notHaveCouponScanner,
                    loading: false
                });
            } else {
                this.notify('error', responseData.message);
            }
        } catch (error) {
            this.notify('error', 'Failed to load data. Please check your network connection.');
        } finally {
            this.setState({ loading: false });
        }
    }


    handleSearchInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    render() {
        const { notHaveAutoBCL, notHaveCouponScanner } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Client Review List</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={this.props.t(`Client Review List`)}
                            breadcrumbItem={this.props.t(`Client Review List`)}
                        />
                        <ToastContainer />
                        <Row>
                            <Col md={6}>
                                <Card>
                                    <CardBody>
                                        <h5>Don't have Auto BCL &nbsp;
                                            <span className="btn-sm btn-warning">
                                                {notHaveAutoBCL.length}
                                            </span>
                                            &nbsp;{this.state.loading ? <Spinner color="primary" size="sm" /> : ' '}
                                        </h5>
                                        <div className="table-responsive">
                                            {/* show table view with two columns serial number and store name x-scroll */}
                                            <Table className="table-striped table-hover table-md" style={{ width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Name</th>
                                                        <th>Store</th>
                                                        <th>Plan</th>
                                                        <th>Install Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {notHaveAutoBCL.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.store_name}</td>
                                                            <td>{item.store_domain}</td>
                                                            <td>{item.plan}</td>
                                                            <td>{DateHelper.twoDigitDate(item.created_at)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md={6}>
                                <Card>
                                    <CardBody>
                                        <h5>Don't have Coupon Scanner (CS) &nbsp;
                                            <span className="btn-sm btn-success">
                                                {notHaveCouponScanner.length}
                                            </span>
                                            &nbsp; {this.state.loading ? <Spinner color="primary" size="sm" /> : ' '}
                                        </h5>
                                        <div className="table-responsive">
                                            <Table className="table-striped table-hover table-md table-hover-cursor" style={{ width: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Name</th>
                                                        <th>Store</th>
                                                        <th>Plan</th>
                                                        <th>Install Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {notHaveCouponScanner.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.store_name}</td>
                                                            <td>{item.store_domain}</td>
                                                            <td>{item.plan}</td>
                                                            <td>{DateHelper.twoDigitDate(item.created_at)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

ClientReviewList.propTypes = {
    t: PropTypes.any
};

export default withTranslation()(ClientReviewList);